<template>
    <div>
        <p v-for="(percentage, percentageIndex) in percentages">
            <input
                v-model.number="percentage.percentage"
                type="number"
                max="100"
                min="0"
                step="1"
                class="form-input inline-block"
                style="width: 90px;"
                @change="refreshControls"
                @keydown.enter="preventSubmit"
            >&nbsp;%
            <input
                v-model="percentage.description"
                type="text"
                placeholder="Beskrivning"
                class="form-input inline-block ml-xl"
                style="width: 360px;"
                @input="refreshControls"
                @keydown.enter="preventSubmit"
            >
            <a
                href="#"
                class="btn btn-md is-danger ml-xl"
                @click="removePercentage(percentageIndex)"
            >
                <font-awesome-icon icon="times" />
            </a>
        </p>
        <p
            class="font-bold mb-3xl mt-2xl pt-md"
            :class="! isTotalPercentageValid ? 'text-danger' : ''"
            style="border-top: 1px solid #d6d6d6;"
        >
            <span class="inline-block" style="padding-left: 17px; width: 90px;">
                <span v-if="isTotalPercentageValid">
                    {{ totalPercentage }}
                </span>
                <span v-else>
                    {{ isTotalPercentageNumeric ? totalPercentage : '???' }}
                </span>
            </span>&nbsp;%
            <span class="inline-block ml-xl" style="padding-left: 17px;">
                {{ isTotalPercentageValid ? 'Totalt.' : 'Obs: Procentsatserna måste summera till 100 %.' }}
            </span>
        </p>
        <input
            v-model="percentagesJson"
            type="hidden"
            name="percentages"
        >
    </div>
</template>
<script>
    export default {
        props: {
            initialPercentages: {
                type: Array,
                required: false,
                default: () => [],
            },
        },

        data() {
            return {
                percentages: this.initialPercentages,
            };
        },

        computed: {
            areAllPercentagesSet: function () {
                if (this.isTotalPercentageNumeric && this.totalPercentage >= 100) return false;

                let areAllDescriptionsSet = true;
                let areAllPercentagesSet = true;

                for (let i = this.percentages.length - 1; i >= 0; i--) {
                    if (! this.percentages[i].percentage) {
                        areAllPercentagesSet = false;
                    }

                    if (!  this.percentages[i].description) {
                        areAllDescriptionsSet = false;
                    }
                }

                if (areAllDescriptionsSet) {
                    return true;
                }

                if (areAllPercentagesSet) {
                    return true;
                }

                return false;
            },
            isTotalPercentageNumeric: function () {
                return Number.isInteger(this.totalPercentage);
            },
            isTotalPercentageValid: function () {
                return this.totalPercentage === 100;
            },
            percentagesJson: function () {
                if (! this.isTotalPercentageValid) return JSON.stringify([]);

                const validPercentages = this.percentages.filter((percentage, percentageIndex) => this.isPercentageValid(percentageIndex));

                return JSON.stringify(validPercentages);
            },
            totalPercentage: function () {
                return this.percentages.reduce((accumulated, percentage) => (accumulated + percentage.percentage), 0);
            },
        },

        beforeMount: function () {
            this.refreshControls();
        },

        methods: {
            addPercentage: function () {
                this.percentages.push({
                    description: '',
                    percentage: 0,
                });
            },
            isPercentageValid: function (percentageIndex) {
                const percentage = this.percentages[percentageIndex];

                if (! percentage) return false;

                if (! Number.isInteger(percentage.percentage)) return false;

                if (percentage.percentage < 0) return false;
                if (percentage.percentage > 100) return false;

                if (percentage.percentage === 0) return !! percentage.description;

                return true;
            },
            preventSubmit: function (e) {
                if (this.isTotalPercentageValid) return true;

                e.preventDefault();

                return false;
            },
            refreshControls: function () {
                if (this.areAllPercentagesSet) {
                    this.addPercentage();
                }
            },
            removePercentage: function (percentageIndex) {
                this.percentages.splice(percentageIndex, 1);

                this.refreshControls();
            },
        },
    };
</script>
<style scoped>
</style>
